<!-- Events -->
<!-- itemCreated -->

<template>
  <base-sq-card
    style="max-width: 600px"
  >
    <template v-slot:heading>
      <span class="tile-card-heading">Invoices</span>
      <v-spacer></v-spacer>
      <v-btn
        v-if="selectableItems"
        fab
        small
        color="green"
        class="mr-3"
        @click="dlgSendInvoices = true"
      >
        <v-icon>
          mdi-mail
        </v-icon>
      </v-btn>
      <base-btn-menu
        v-if="isStaff"
        icon="mdi-dots-vertical"
      >
        <v-list>
          <v-list-item
            link
            @click="getInvoices()"
          >
            <v-list-item-title>
              <v-icon
                color="blue darken-1"
                class="mr-1"
              >
                mdi-refresh
              </v-icon>

              Refresh
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="selectableItems = !selectableItems"
          >
            <v-list-item-title>
              <v-icon
                :color="selectableItems ? 'red darken-1' : 'green darken-1'"
                class="mr-1"
              >
                mdi-mail
              </v-icon>
              <template
                v-if="selectableItems"
              >
                Cancel send
              </template>
              <template
                v-else
              >
                Send Invoices
              </template>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </base-btn-menu>
    </template>
    <v-row>
      <v-data-table
        v-model="selectedInvoices"
        :headers="headers"
        :items="items"
        :items-per-page="5"
        :loading="overlayDisplay"
        :show-select="selectableItems"
        :single-select="false"
        item-key="invoice"
        style="max-width: 600px"
        height="350px"
      >
        <template v-slot:item.due_date="{ item }">
          {{ formatDate(item.due_date) }}
        </template>
        <template v-slot:item._action="{ item }">
          <base-btn-menu>
            <v-list>
              <v-list-item
                link
                :href="'/#/public-reporting/invoice?account=' + selectedAccount.rowkey + '&invoice=' + item.invoice"
                target="_blank"
              >
                <v-list-item-title>
                  <v-icon
                    color="blue darken-1"
                    class="mr-1"
                  >
                    mdi-file-find
                  </v-icon>

                  Preview
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                link
                @click="doStartInvDownload(item)"
              >
                <v-list-item-title>
                  <v-icon
                    color="green darken-1"
                    class="mr-1"
                  >
                    mdi-download
                  </v-icon>

                  Download
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </base-btn-menu>
        </template>
      </v-data-table>
    </v-row>
    <!--           Email Invoices Modal-->
    <v-dialog
      v-model="dlgSendInvoices"
      max-width="600px"
    >
      <base-sq-card
        title="Email Invoices"
        :dialog="true"
      >
        <v-row
          style="width:90%"
          class="mx-auto"
        >
          <v-col
            cols="12"
            class="mx-auto"
          >
            <v-combobox
              v-model="selectedFormRecipient"
              :search-input.sync="recipientSearch"
              :items="users"
              style="width:85%"
              class="mx-auto"
              item-text="email_address"
              item-value="email_address"
              label="Recipient Email"
            ></v-combobox>
          </v-col>
          <v-col cols="12">
            <h2>Selected Invoices</h2>
            <v-list>
              <v-list-item
                v-for="(invoice,idx) of selectedInvoices"
                :key="idx +'-' + invoice.invoice"
                class="mb-n6"
              >
                {{ invoice.invoice}}
              </v-list-item>
            </v-list>
          </v-col>
          <v-col
            cols="12"
          >
            <v-card
              v-if="formErrors.length > 0"
              flat
              class="mr-7"
            >
              <v-alert
                type="error"
                v-for="(e, i) in formErrors"
                :key="i"
              >
                {{ e }}
              </v-alert>
            </v-card>
            <v-card
              v-if="sendSuccess"
            >
              <v-alert
                color="success"
              >
                Email sent successfully to {{ recipientSearch }}
              </v-alert>
            </v-card>
          </v-col>
        </v-row>
        <template v-slot:actions>
          <v-row>
            <v-col cols="12">
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                class="mr-6"
                text
                @click="resetEmailForm"
              >
                {{ sendSuccess ? 'Close' : 'Cancel'}}
              </v-btn>
              <v-btn
                color="primary"
                class="mr-12"
                text
                @click="doSendInvoices"
              >
                Send Invoices
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </base-sq-card>
      <v-overlay :value="overlaySending">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-dialog>
  </base-sq-card>
</template>

<script>
  // Utilities
  import { mapActions, mapGetters } from 'vuex'
  import {
    _DOWNLOAD_INVOICE,
    ACCT_GET_ACCOUNT_INVOICES, ACCT_SEND_INVOICES,
  } from '../../store/actions.types'
  import basicMixin from '../../mixins/basic'
  export default {
    name: 'PowAccountInvoices',

    mixins: [basicMixin],
    inheritAttrs: false,

    props: {
      item: {
        type: Object,
        default: () => ({
          name: undefined,
          invoice: undefined,
          due_date: undefined,
          total: undefined,
          paid: undefined,
          is_paid: undefined,
          details: undefined,
        }),
      },
    },
    data: function () {
      return {
        currentObject: {},
        snapshotObject: {},
        formMode: '',
        formErrors: [],
        overlayAbsolute: true,
        overlayDisplay: false,
        selectableItems: false,
        selectedInvoices: [],
        headers: [
          { text: '', value: '_action' },
          {
            text: 'Invoice',
            align: 'start',
            sortable: false,
            value: 'invoice',
          },
          { text: 'Due', value: 'due_date' },
          { text: 'Amount', value: 'total' },
          { text: 'Bal', value: 'balance' },
          { text: 'Status', value: 'status' },
        ],
        dlgSendInvoices: false,
        selectedFormRecipient: '',
        recipientSearch: '',
        overlaySending: false,
        sendSuccess: false,
      }
    },
    watch: {
      recipientSearch: {
        handler (val, oldVal) {
          this.resetForm()
        },
      },
    },
    computed: {
      ...mapGetters({
        items: 'acctSelectedAccountInvoices',
        users: 'acctSelectedAccountUsers',
        selectedAccount: 'acctSelectedAccount',
      }),
      calculatedHeaders: function () {
        const calcd = this.headers.filter((col) => {
          if (!this.isStaff && col.staff) {
            return false
          }
          return true
        })
        return calcd
      },
    },
    async created () {
      // this.init()
    },
    async mounted () {
      this.init()
    },
    methods: {
      ...mapActions({
        getInvoices: ACCT_GET_ACCOUNT_INVOICES,
        downloadInvoice: _DOWNLOAD_INVOICE,
        sendInvoices: ACCT_SEND_INVOICES,
      }),
      async init () {
        console.log(`Initializing ${name} setting values!`, this.item)
        this.formMode = 'read'
        this.overlayDisplay = true
        await this.getInvoices()
        this.overlayDisplay = false
        // console.log(val)
        // this.currentObject = { ...this.item }
        // this.snapshotObject = { ...this.item }
      },
      resetForm () {
        this.sendSuccess = false
        this.overlayDisplay = false
        this.currentObject = { ...this.snapshotObject }
        this.formErrors = []
      },
      resetEmailForm () {
        this.sendSuccess = false
        this.dlgSendInvoices = false
        this.selectedFormRecipient = ''
        this.formErrors = []
      },
      async doStartInvDownload (invoice) {
        console.log(invoice)
        const invPayload = {
          account_key: this.selectedAccount.rowkey,
          invoice_key: invoice.invoice,
          filename: `invoice_${invoice.invoice}`,
        }
        await this.downloadInvoice(invPayload)
      },
      async doSendInvoices () {
        this.overlaySending = true
        this.commitLog({ message: `preparing to send email with invoices to ${this.recipientSearch} for`, selectedInvoices: this.selectedInvoices })
        try {
          const sendPayload = {
            recipient: this.recipientSearch,
            invoices: this.selectedInvoices.map((invoice) => invoice.invoice),
          }
          const { data } = await this.sendInvoices(sendPayload)
          if (data && data.status !== 'sent') {
            this.formErrors.push('Error sending invoices')
          } else {
            this.sendSuccess = true
          }
        } catch (e) {
          this.commitLog({ message: 'Exception thrown sending invoices', error: e })
        }
        this.overlaySending = false
      },
    },

  }
</script>

<style>
</style>
